// extracted by mini-css-extract-plugin
export default {"header":"styles_header__APqFU","allNotifications":"styles_allNotifications__gekyO","arrow":"styles_arrow__lZn8Q","titleWrapper":"styles_titleWrapper__lEl7S"};